import script from "./LoginForgetView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginForgetView.vue?vue&type=script&lang=ts&setup=true"

import "./LoginForgetView.vue?vue&type=style&index=0&id=b7b3bd84&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/jobs/MYNAVI_MP_VIEW_G_PROD/workspace/view/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7b3bd84"]])

export default __exports__